import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { CustomIntervalDialogComponent } from './custom-interval-dialog.component';

@NgModule({
  declarations: [CustomIntervalDialogComponent],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,

    MatDialogModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatDatepickerModule,
  ],
  exports: [CustomIntervalDialogComponent],
})
export class CustomIntervalDialogModule { }
